import WRAP from "WRAP-JS";
import LegendAirway from "../legend/LegendAirway";
import {
  configAirwayDh,
  configAirwayLayer,
  configAirwayLabelLayer
} from "./config/ConfigAirway";
import { MAP_ID_AIRWAY } from "../../../store/MapContentsState";

export const AIRWAY_LEVEL_BOTH = 'BOTH';
export const AIRWAY_LEVEL_HIGH = 'HIGH';
export const AIRWAY_LEVEL_LOW  = 'LOW';

class Airway {
  static NAME = MAP_ID_AIRWAY
  static AIRWAY_INTERNATIONAL_NAME = Airway.makeContentsKey("ITN");
  static AIRWAY_DOMESTIC_NAME = Airway.makeContentsKey("DOM");
  static AIRWAY_OTHER_NAME = Airway.makeContentsKey("OTH");
  static AIRWAY_LABEL = Airway.makeContentsKey("LABEL");

  contentsVisibleState = {
    [Airway.AIRWAY_INTERNATIONAL_NAME]: true,
    [Airway.AIRWAY_DOMESTIC_NAME]: true,
    [Airway.AIRWAY_OTHER_NAME]: true,
  };

  dhAirway;
  layerAirway;
  layerAirwayLabel;
  labelVisibleState;
  level;
  ready = false;

  constructor() {
    this.layerAirway = new WRAP.Geo.Layer(Airway.AIRWAY_INTERNATIONAL_NAME);
    this.layerAirway.setVisible(false);
    this.layerAirwayLabel = new WRAP.Geo.Layer(Airway.AIRWAY_LABEL);
    this.layerAirwayLabel.setVisible(false);
  }

  initialize() {
    this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {
    this.dhAirway = new WRAP.Data(configAirwayDh);
  }

  initLayer() {
    this.layerAirway.configure(this.dhAirway, configAirwayLayer);
    this.layerAirwayLabel.configure(this.dhAirway, configAirwayLabelLayer);

    this.labelVisibleState = true;
    this.setLevel(AIRWAY_LEVEL_BOTH);

    const displayToolTip = (geo) => {
      return geo.properties.name;
    };

    this.layerAirway.setTooltip(displayToolTip);

    const attributes = {
      filter: this._visibleFilter.bind(this),
      level: () => this.level
    }
    this.layerAirway.setAttributes(attributes);
    this.layerAirwayLabel.setAttributes(attributes);
  }

  async drawLayer(visible) {
    if (!this.ready) {
      this.initialize();
    }
    this.setVisible(visible);
  }
  getLayer() {
    return [this.layerAirway, this.layerAirwayLabel];
  }

  setVisible(visible, contents) {
    if (!this.ready) return;

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      this.layerAirway.invalidate();
      this.layerAirwayLabel.invalidate();
    } else {
      if(visible) {
        this.layerAirway.show();
      } else {
        this.layerAirway.hide();
      }
      if(visible && this.labelVisibleState) {
        this.layerAirwayLabel.show();
      } else {
        this.layerAirwayLabel.hide();
      }
    }
  }

  getLegend() {
    return {
      id: Airway.NAME,
      label: 'AIRWAY',
      component: LegendAirway,
      contents: this
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  getLabelVisibleState() {
    return this.labelVisibleState;
  }

  setLabelVisibleState(visible) {
    this.labelVisibleState = visible;
    if (visible) {
      this.layerAirwayLabel.show();
    } else {
      this.layerAirwayLabel.hide();
    }
  }

  getLevel() {
    return this.level;
  }

  setLevel(level) {
    if (level === this.level) return;

    this.level = level;
    this.layerAirway.invalidate();
  }

  changeRoutePointEditing(routePointEditing) {
    this.layerAirway.disableInteraction(routePointEditing);
  }

  _visibleFilter(feature) {
    return this.contentsVisibleState[ Airway.makeContentsKey(feature.properties.kind) ];
  }

  static makeContentsKey(kind) {
    return `${Airway.NAME}_${kind}`;
  }
}

export default Airway;